import { useQueryCashed } from "@/hooks/useQueryCashed";

import { MailListApi } from "../api";
import { MailListQueryParams } from "../models";

export const useMailList = <T>(params: MailListQueryParams<T>) => {
  return useQueryCashed({
    queryKey: ["MAIL_LIST", { ...params }],
    queryFn: async () => {
      return MailListApi.get<T>(params);
    },
  });
};
